import headerTemplate from './templates/header';

export default function templates() {
	headerTemplate();
}